import { styled } from '@linaria/react'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'
import { Wrapper } from '../../TextBlock.styled'

export const TextBlockSubscriptionStatusSC = styled(Wrapper)`
  gap: var(${FIXED_INDENTS.INDENT_40});
  margin-bottom: var(${FIXED_INDENTS.INDENT_50});

  ${MEDIA.MIN_600} {
    gap: var(${FIXED_INDENTS.INDENT_50});
    margin-bottom: var(${FIXED_INDENTS.INDENT_60});
  }

  ${MEDIA.MIN_1240} {
    gap: var(${FIXED_INDENTS.INDENT_60});
    margin-bottom: var(${FIXED_INDENTS.INDENT_80});
  }
`
